// Values come from .env (Create React App only exposes REACT_APP_* variables,
// and reads them when the dev server or build starts).
const requireEnv = (name: string, value: string | undefined) => {
  if (!value) {
    throw new Error(`Missing ${name} in .env`);
  }
  return value;
};

export const config = {
  baseUrl: {
    default: requireEnv(
      "REACT_APP_API_BASE_URL",
      process.env.REACT_APP_API_BASE_URL,
    ),
  },
};

export const theLastSpellingBeeReCaptchaKey = requireEnv(
  "REACT_APP_RECAPTCHA_KEY",
  process.env.REACT_APP_RECAPTCHA_KEY,
);
